import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";
import type { FormQuery } from "../../../../../core/service/types/FormQuery";
import type { Dto } from "../../../../../core/types/be/Dto";
import type { LoyaltyMessageEntity } from "../../types/LoyaltyMessageEntity";
import { LoyaltyMessageDtoToEntity } from "../mappers/LoyaltyMessageDtoToEntity";
import { LoyaltyMessageEntityToDto } from "../mappers/LoyaltyMessageEntityToDto";

const LoyaltyMessageApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        LoyaltyMessageLoad: builder.query<LoyaltyMessageEntity, FormQuery>({
            providesTags: [ResourceName.LOYALTY_MESSAGES],
            query: () => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.LOYALTY_MESSAGES}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return LoyaltyMessageDtoToEntity(response);
            },
        }),
        LoyaltyMessageUpdate: builder.mutation<LoyaltyMessageEntity, FormMutation<LoyaltyMessageEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.LOYALTY_MESSAGES}/${mutation.data.id}`;
                const method = "PUT";

                const body = LoyaltyMessageEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.LOYALTY_MESSAGES],
        }),
    }),
});

export const { useLoyaltyMessageLoadQuery, useLoyaltyMessageUpdateMutation } = LoyaltyMessageApi;
